import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { changeMatrix } from '../../helpers/state';

// background: rgb(255, 255, 230);
// border: 1px solid #8c8c00;
// outline: 1px solid #ffff00;
// background: transparent;
// border: 1px solid ${kassimGreen};
// border: none;
// outline: none;
// outline: 1px solid #8c8c00;

// optie 4:
// background: transparent;
// border: 1px solid ${kassimGreen};
// outline: 1px solid #ffff00;

const inputStyle = css`
    background: rgb(255, 255, 230);
    border: 1px solid #8c8c00;
    ${(props) => props.error && `border-color: red; outline-color: red;`}
    &:focus-visible {
        outline: 1px solid #ffff00;
    }
    &:disabled {
        background: transparent;
        border-color: #999;
        color: #777;
        opacity: 1;
    }
`;
const inputGameVariant = css`
    padding: 2px 4px;
    border-radius: 2px;
`;

const FieldInput = styled.input`
    width: ${(props) =>
        props.controlwidth
            ? props.controlwidth
            : props.type === 'date'
            ? 130
            : 80}px;
    ${inputStyle}

    ${({ variant }) => {
        return variant === 'game' && inputGameVariant;
    }};
`;
/* text-align: ${(props) =>
        props.type === 'number' ? 'right' : 'left'};
    width: 100%; */
const columnWidth = 50;
const TableCellInput = styled(FieldInput)`
    width: ${columnWidth}px;
    margin-right: 2px;
    margin-bottom: 2px;
`;

const HeaderLabel = styled.div`
    display: inline-block;
    width: ${columnWidth}px;
    /* font-weight: bold; */
    font-size: 12px;
`;

const FieldInputSelect = styled.select`
    ${inputStyle}
    width: ${(props) => (props.controlwidth ? props.controlwidth : 120)}px;
`;
const StyledTextarea = styled.textarea`
    ${inputStyle}
    width: 100%;
    flex-grow: 1;
    height: 100px;
    font-family: inherit;
`;
export const Header = styled.div`
    margin-top: 16px;
    margin-bottom: 8px;
    font-weight: bold;
`;

/**
 *
 * @param {Object} props
 * @param {string} props.id
 * @param {{value: (string|number), label: string }[]} props.items
 * @returns {*}
 */
export const ComboBox = ({
    id,
    items,
    value,
    onChange,
    controlwidth,
    readonly,
    error,
}) => {
    const handleChange = (ev) => {
        const val = ev.target.value;
        onChange(val);
    };
    return (
        <FieldInputSelect
            name={id}
            id={id}
            value={value}
            onChange={handleChange}
            controlwidth={controlwidth}
            readonly={readonly}
            disabled={readonly}
            error={error}
        >
            {items.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </FieldInputSelect>
    );
};
/**
 *
 * @param {Object} props
 * @param {string} props.id
 * @param {string|number} props.value
 * @returns {*}
 */
export const TextBox = forwardRef(
    (
        {
            id,
            value,
            onChange,
            autoFocus,
            controlwidth,
            placeholder,
            readonly,
            error,
            helperText,
            variant,
        },
        ref
    ) => {
        const handleChange = (ev) => {
            const val = ev.target.value;
            onChange(val);
        };
        return (
            <FieldInput
                name={id}
                id={id}
                type="text"
                value={value}
                placeholder={placeholder}
                onChange={handleChange}
                ref={ref}
                autoFocus={autoFocus}
                controlwidth={controlwidth}
                readonly={readonly}
                disabled={readonly}
                error={error}
                helperText={helperText}
                variant={variant}
            />
        );
    }
);

/**
 *
 * @param {Object} props
 * @param {string} props.id
 * @param {string} props.value
 * @returns {*}
 */
export const TextArea = ({
    id,
    value,
    placeholder,
    onChange,
    controlwidth,
    readonly,
    error,
}) => {
    const handleChange = (ev) => {
        const val = ev.target.value;
        onChange(val);
    };
    return (
        <StyledTextarea
            name={id}
            id={id}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            controlwidth={controlwidth}
            readonly={readonly}
            disabled={readonly}
            error={error}
        />
    );
};
/**
 *
 * @param {Object} props
 * @param {string} props.id
 * @param {string} props.value
 * @returns {*}
 */

const StyledTextLabel = styled.div`
    display: inline-block;
`;
export const TextLabel = ({ id, value }) => {
    return <StyledTextLabel id={id}>{value}</StyledTextLabel>;
};

/**
 *
 * @param {Object} props
 * @param {string} props.id
 * @param {{value: (string|number), label: string }[]} props.items
 * @returns {*}
 */
export const NumberBox = ({
    id,
    value,
    onChange,
    bounds,
    step,
    controlwidth,
    readonly,
    error,
    variant,
}) => {
    const handleChange = (ev) => {
        const val = ev.target.value;
        onChange(val);
    };
    function calcStep(bounds) {
        const s = (bounds[1] - bounds[0]) / 100;
        // round to nearest lower power of 10:
        const precision = Math.floor(Math.log10(s));
        if (precision < 0) {
            return 1 / 10 ** -precision;
        }
        return 10 ** precision;
    }
    const boundProps =
        bounds?.length === 2
            ? {
                  min: bounds[0],
                  max: bounds[1],
                  step: step ? step : calcStep(bounds),
              }
            : {};
    return (
        <FieldInput
            variant={variant}
            name={id}
            id={id}
            type="number"
            value={value}
            onChange={handleChange}
            controlwidth={controlwidth}
            {...boundProps}
            readonly={readonly}
            disabled={readonly}
            error={error}
        />
    );
};

/**
 *
 * @param {Object} props
 * @param {string} props.id
 * @param {string} props.label
 * @param {string} props.value - date string
 * @returns {*}
 */
export const Datepicker = ({
    id,
    value,
    onChange,
    controlwidth,
    readonly,
    error,
}) => {
    const handleChange = (ev) => {
        const val = ev.target.value;
        onChange(val);
    };
    return (
        <FieldInput
            name={id}
            id={id}
            type="date"
            value={value?.slice(0, 10)}
            onChange={handleChange}
            controlwidth={controlwidth}
            disabled={readonly}
            error={error}
        />
    );
};

/**
 *
 * @param {Object} props
 * @param {string} props.id
 * @param {string} props.label
 * @param {string} props.value - date-time string
 * @returns {*}
 */
export const DateTimepicker = ({
    id,
    value,
    onChange,
    controlwidth,
    readonly,
    error,
}) => {
    const handleChange = (ev) => {
        const val = ev.target.value;
        onChange(val.replace('T', ' ') + ':00');
    };

    return (
        <FieldInput
            name={id}
            id={id}
            type="datetime-local"
            value={value.replace(' ', 'T')}
            onChange={handleChange}
            controlwidth={controlwidth || 180}
            disabled={readonly}
            error={error}
        />
    );
};

function range(size, startAt = 0) {
    return [...Array(size).keys()].map((i) => i + startAt);
}

/**
 *
 * @param {Object} props
 * @param {string} props.id
 * @param {string} props.label
 * @param {string} props.headerLabels
 * @param {string[][]} props.value - date string
 * @returns {*}
 */
export const InputTable = ({
    id,
    value,
    headerLabels,
    onChange,
    controlwidth,
    readonly,
    error,
    variant,
}) => {
    const numCols = value?.length > 0 ? value[0].length : 0;
    const numRows = value?.length || 0;

    const getHandleChange = (row, col) => (ev) => {
        const val = ev.target.value;
        onChange(changeMatrix(value, row, col, () => val));
    };

    return (
        <div>
            <div>
                {range(numCols).map((col) => {
                    let colHead =
                        col < headerLabels?.length ? headerLabels[col] : '';
                    return <HeaderLabel key={col}>{colHead}</HeaderLabel>;
                })}
            </div>
            {range(numRows).map((row) => {
                return (
                    <div key={row}>
                        {range(numCols).map((col) => (
                            <TableCellInput
                                name={`${id}-${row}-${col}`}
                                id={`${id}-${row}-${col}`}
                                key={`${id}-${row}-${col}`}
                                value={value[row][col]}
                                onChange={getHandleChange(row, col)}
                                disabled={readonly}
                                error={error}
                                variant={variant}
                            />
                        ))}
                    </div>
                );
            })}
        </div>
    );
};
